import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import FeesActiveContent from "./FeesActiveContent";
import feesJobProfileType from "../types/feesJobProfileType";
import errorsType from "../types/errorsType";
import {
  SectionTitle,
  Label,
  LabelText,
  RadioButtonGroup,
  RadioButtonWrapper,
  RadioButton,
  RadioButtonLabel,
  Check,
} from "../styles/edit-form-styles";

class FeesAndSkills extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeRadioButtonID: "",
    };
  }

  componentDidMount() {
    this.handleJobType();
  }

  componentWillUnmount() {
    this.handleJobType();
  }

  handleJobType = () => {
    const { jobProfile } = this.props;
    const { jobType } = jobProfile;

    if (jobType === "contract") {
      this.setState({ activeRadioButtonID: "contract" });
    }
  };

  handleRadioButton = (e) => {
    const { jobTypeOnChange } = this.props;

    this.setState({ activeRadioButtonID: e.target.id });
    jobTypeOnChange(e);
  };

  render() {
    const { activeRadioButtonID } = this.state;
    const {
      jobProfile,
      inputOnChange,
      salaryTypeOnChange,
      errors,
      currencyOptions,
    } = this.props;
    const { jobType } = jobProfile;

    return (
      <Fragment>
        <SectionTitle>Salary & Agency Fee</SectionTitle>
        <Label htmlFor="job-type">
          <LabelText>Job Type</LabelText>
        </Label>
        <RadioButtonGroup>
          <RadioButtonWrapper>
            <RadioButton
              onChange={this.handleRadioButton}
              checked={jobType === "permanent"}
              name="jobType"
              id="permanent"
              type="radio"
            />
            <RadioButtonLabel htmlFor="permanent">Permanent</RadioButtonLabel>
            <Check />
          </RadioButtonWrapper>
          <RadioButtonWrapper>
            <RadioButton
              onChange={this.handleRadioButton}
              checked={jobType === "contract"}
              name="jobType"
              id="contract"
              type="radio"
            />
            <RadioButtonLabel htmlFor="contract">Contract</RadioButtonLabel>
            <Check />
          </RadioButtonWrapper>
        </RadioButtonGroup>
        <FeesActiveContent
          inputOnChange={inputOnChange}
          jobProfile={jobProfile}
          salaryTypeOnChange={salaryTypeOnChange}
          activeRadioButtonID={activeRadioButtonID}
          errors={errors}
          currencyOptions={currencyOptions}
        />
      </Fragment>
    );
  }
}

FeesAndSkills.propTypes = {
  inputOnChange: PropTypes.func.isRequired,
  jobTypeOnChange: PropTypes.func.isRequired,
  salaryTypeOnChange: PropTypes.func.isRequired,
  jobProfile: feesJobProfileType.isRequired,
  errors: errorsType.isRequired,
};

export default FeesAndSkills;
